import { useLocation } from 'react-router-dom';

export const useQueryStringParam = (field) => {
    const search = useLocation().search;
    return new URLSearchParams(search).get(field);
}